import { render, staticRenderFns } from "./MisCalificaciones.vue?vue&type=template&id=40f3c67c&"
import script from "./MisCalificaciones.vue?vue&type=script&lang=js&"
export * from "./MisCalificaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports